<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="modal-drop-out">
    <div class="modal-header">
      <div class="icon-ajuntament" />
      <div class="icon-close" @click="modalClose" />
    </div>
    <span class="drop-out-title">{{ $t('drop_out_confirm') }}</span>
    <div class="buttons-wrapper">
      <div class="button cancel" @click="modalClose">
        <span>{{ $t('cancel') }}</span>
      </div>
      <div class="button accept" @click="confirmDropOut">
        <span>{{ $t('agree') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Renders a modal with news info
 * @example [none]
 */
export default {
  name: 'ModalDropOut',
  directives: {},
  components: {},
  props: {
    /**
     * Function for close the modal
     */
    modalClose: {
      type: Function,
    },
  },
  asyncComputed: {},
  computed: {},
  methods: {
    confirmDropOut() {
      this.$router.push({ name: 'Delete' })
    },
  },
}
</script>

<style lang="stylus" scoped>
.modal-drop-out
  display: flex
  flex-direction: column
  height: 100%
  justify-content: space-between
  width: 100%
  z-index: 10

  .buttons-wrapper
    display: flex
    gap: vw(15px)
    justify-content: center
    margin: vw(20px) vw(20px) vw(40px)

    .button
      border: 1px solid black
      border-radius: 4px
      cursor: pointer
      display: flex
      padding: vw(8px) vw(15px)

      &.accept
        background-color: black
        color: white

        &:hover
          background-color: $grey-dark
          color: white

      &.cancel
        background-color: white
        color: black

        &:hover
          background-color: $grey-dark
          color: white

      span
        m-font-size(14, 20)

  .drop-out-title
    m-font-size(26, 30)
    color: $grey-dark
    font-weight: 600
    text-align: center

  .modal-header
    height: vw(62px)
    position: relative
    width: 100%

    .icon-ajuntament
      background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
      background-position: center center
      background-repeat: no-repeat
      background-size: cover
      height: vw(45px)
      margin-left: vw(20px)
      margin-top: vw(20px)
      width: vw(176px)

    .icon-close
      m-icon("modal-close", 32, $grey-dark)
      cursor: pointer
      position: absolute
      right: vw(20px)
      top: vw(20px)
</style>
